import { containerVanConstants } from '../../_constants';
import { containerVanService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const containerVanActions = {
    load,
    loadContainer,
    getContainer,
    createContainer,
    updateContainer,
    updateContainerStatus,
    deleteContainer,
    searchCVCTS,
    clearContainerVan,
    updateCvIsUsed,
    getAllBookingContainer,
    searchCVHustling,
}

function containerVanFetched() { return { type: containerVanConstants.CONTAINER_VAN_FETCHED } }
function containerVanFetching() { return { type: containerVanConstants.CONTAINER_VAN_FETCHING } }

function containerVanSubmitted() { return { type: containerVanConstants.CONTAINER_VAN_SUBMITTED } }
function containerVanSubmitting() { return { type: containerVanConstants.CONTAINER_VAN_SUBMITTING } }

function clearContainerVan() { return { type: containerVanConstants.CONTAINER_VAN_CLEAR } }

function load(skip, take, search) {
    return dispatch => {
        dispatch(containerVanFetching());
        dispatch(userActions.allowLeavePage());
        containerVanService.load(skip, take, search)
            .then(
                containers => {
                    if (containers.length > 0) {
                        dispatch(success(containers));
                        dispatch(containerVanFetched());
                    } else {
                        dispatch(containerVanFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(containers) { return { type: containerVanConstants.GET_CONTAINERS, containers } }
}
function loadContainer(skip, take, search) {
    return dispatch => {
        dispatch(containerVanFetching());
        dispatch(userActions.allowLeavePage());
        containerVanService.loadContainer(skip, take, search)
            .then(
                containers => {
                    if (containers.length > 0) {
                        dispatch(success(containers));
                        dispatch(containerVanFetched());
                    } else {
                        dispatch(containerVanFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(containers) { return { type: containerVanConstants.GET_CONTAINERS, containers } }
}
function getContainer(code) {
    return dispatch => {
        dispatch(containerVanFetching());
        dispatch(userActions.allowLeavePage());
        containerVanService.getContainer(code)
            .then(
                container => {
                    if (container.length > 0) {
                        dispatch(success(container));
                        dispatch(containerVanFetched());
                    } else {
                        dispatch(containerVanFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(container) { return { type: containerVanConstants.GET_CONTAINER, container } }
}
function createContainer(payload) {
    return dispatch => {
        dispatch(containerVanSubmitting());
        dispatch(userActions.notallowLeavePage());
        containerVanService.createContainer(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.success('Container van added successfully'))
                    window.location.href = '/master_data/containerVan';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateContainer(payload, code) {
    return dispatch => {
        dispatch(containerVanSubmitting());
        dispatch(userActions.notallowLeavePage());
        containerVanService.updateContainer(payload, code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.success('Container van updated successfully'))
                    window.location.href = '/master_data/containerVan';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateContainerStatus(payload) {
    return dispatch => {
        dispatch(containerVanSubmitting());
        dispatch(userActions.notallowLeavePage());
        containerVanService.updateContainerStatus(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.success('Container van status updated successfully'))
                    window.location.href = '/master_data/containerVan';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteContainer(code, type) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        containerVanService.deleteContainer(code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Container van deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/containerVan';
                            break;
                        default:
                            dispatch(loadContainer(0, 20));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            dispatch(getContainer(code[0]));
                            break;
                        default:
                            dispatch(loadContainer(0, 20));
                            break;
                    }
                }
            );
    };
}
function searchCVCTS(search) {
    return dispatch => {
        dispatch(containerVanFetching());
        containerVanService.searchCVCTS(search)
            .then(
                searchVan => {
                    if (searchVan.length > 0) {
                        dispatch(success(searchVan));
                        dispatch(containerVanFetched());
                    } else {
                        dispatch(containerVanFetched());
                        dispatch(alertActions.warning(searchVan.message))
                    }
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(searchVan) { return { type: containerVanConstants.SEARCH_CONTAINER_VAN, searchVan } }
}
function searchCVHustling(search) {
    return dispatch => {
        dispatch(containerVanFetching());
        containerVanService.searchCVHustling(search)
            .then(
                searchVan => {
                    if (searchVan.length > 0) {
                        dispatch(success(searchVan));
                        dispatch(containerVanFetched());
                    } else {
                        dispatch(containerVanFetched());
                        dispatch(alertActions.warning(searchVan.message))
                    }
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(searchVan) { return { type: containerVanConstants.SEARCH_CONTAINER_VAN, searchVan } }
}
function updateCvIsUsed(payload, action, type) {
    return dispatch => {
        dispatch(containerVanSubmitting());
        containerVanService.updateCvIsUsed(payload, action)
            .then(
                success => {
                    if(type === 'list'){
                        dispatch(loadContainer(0, 20));
                    }
                    else{
                        dispatch(getContainer(payload[0]));
                    }
                    dispatch(alertActions.success('Container van status updated successfully'));
                    dispatch(containerVanSubmitted());
                },
                error => {
                    dispatch(containerVanSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function getAllBookingContainer(search) {
    return dispatch => {
        dispatch(containerVanFetching());
        containerVanService.getAllBookingContainer(search)
            .then(
                bookingContainer => {
                    dispatch(success(bookingContainer));
                    dispatch(containerVanFetched());
                },
                error => {
                    dispatch(containerVanFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(bookingContainer) { return { type: containerVanConstants.ALL_BOOKING_CONTAINER, bookingContainer } }
}